module.exports = __webpack_public_path__ + "img/user-location.2528e8ea.svg";